/* XC TORVAULT モーション拡張 — 設定読込 / 進行ライン / レイヤー切替 / 価格フェード / FAQ単一展開
   すべてこのページ専用スコープ。ライブラリ不使用。 */
(function () {
  'use strict';
  if (window.__xcTvmInit) return;
  window.__xcTvmInit = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.addEventListener('DOMContentLoaded', function () {
    var cfgEl = document.querySelector('[data-xc-motion-config]');
    var cfg = { enable: true, hero: true, reveal: true, progress: true, gloss: true, spsimple: true, stagger: 70, threshold: 20 };
    if (cfgEl) {
      try {
        var parsed = JSON.parse(cfgEl.getAttribute('data-xc-motion-config'));
        for (var k in parsed) cfg[k] = parsed[k];
      } catch (e) { /* 既定値のまま */ }
    }

    var root = document.documentElement;
    /* JSエラーでも初期表示を壊さない: クラス付与は最後にまとめて行わず、tryで守る */
    try {
      if (cfg.enable) {
        root.classList.add('xc-mo');
        root.style.setProperty('--xc-mo-stagger', (cfg.stagger || 70) + 'ms');
        if (cfg.spsimple) root.classList.add('xc-mo-spsimple');
        if (!cfg.hero) root.classList.add('xc-mo-nohero');
        if (!cfg.gloss) root.classList.add('xc-mo-nogloss');
      }
    } catch (e) { root.classList.remove('xc-mo'); }

    /* ---------- ヘッダー進行ライン(rAFでまとめて更新 / passive) ---------- */
    var bar = document.querySelector('[data-xc-tvh-progress]');
    if (bar && cfg.enable && cfg.progress) {
      var ticking = false;
      var update = function () {
        var doc = document.documentElement;
        var max = doc.scrollHeight - window.innerHeight;
        var p = max > 0 ? Math.min(1, Math.max(0, window.scrollY / max)) : 0;
        bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
        ticking = false;
      };
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      }, { passive: true });
      update();
    } else if (bar) {
      bar.style.display = 'none';
    }

    /* ---------- 収納ストレージ: レイヤー切替 ---------- */
    document.querySelectorAll('[data-xc-lswitch]').forEach(function (sec) {
      var tabs = sec.querySelectorAll('[data-xc-ltab]');
      var panes = sec.querySelectorAll('[data-xc-lpane]');
      if (!tabs.length || !panes.length) return;
      function select(mode) {
        sec.setAttribute('data-xc-lmode', mode);
        tabs.forEach(function (t) {
          t.setAttribute('aria-pressed', t.getAttribute('data-xc-ltab') === mode ? 'true' : 'false');
        });
        panes.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-xc-lpane') === mode);
        });
      }
      tabs.forEach(function (t) {
        t.addEventListener('click', function () { select(t.getAttribute('data-xc-ltab')); });
      });
      select(sec.getAttribute('data-xc-lmode') || 'all');
    });

    /* ---------- カラー切替: 価格・名称の短いフェード(値は即時に正値) ---------- */
    if (cfg.enable && !reduced) {
      document.querySelectorAll('[data-xc-purchase]').forEach(function (sec) {
        sec.addEventListener('change', function (e) {
          if (!e.target.matches('input[type="radio"]')) return;
          [
            sec.querySelector('[data-xc-colors-price]'),
            sec.querySelector('[data-xc-selected-name]')
          ].forEach(function (el) {
            if (!el) return;
            el.classList.add('xc-swapfade');
            setTimeout(function () { el.classList.remove('xc-swapfade'); }, 150);
          });
        });
      });
    }

    /* ---------- FAQ: 単一展開モード(セクション設定) ---------- */
    document.querySelectorAll('[data-xc-faq-single]').forEach(function (wrap) {
      wrap.addEventListener('toggle', function (e) {
        var d = e.target;
        if (!(d instanceof HTMLDetailsElement) || !d.open) return;
        wrap.querySelectorAll('details[open]').forEach(function (other) {
          if (other !== d) {
            var s = other.querySelector('summary');
            if (s) s.click(); else other.open = false;
          }
        });
      }, true);
    });

    /* ---------- ヘッダー: スクロール時の締まり(rAFで1回/フレーム・passive) ---------- */
    var tvh = document.querySelector('[data-xc-tvh]');
    if (tvh && cfg.enable) {
      var scrTick = false;
      var syncScrolled = function () {
        tvh.classList.toggle('is-scrolled', window.scrollY > 12);
        scrTick = false;
      };
      window.addEventListener('scroll', function () {
        if (scrTick) return;
        scrTick = true;
        requestAnimationFrame(syncScrolled);
      }, { passive: true });
      syncScrolled();
    }

    /* ---------- PCヒーロー: 弱いポインターパララックス ----------
       最大X6px/Y4px/回転0.25deg。CSS変数のみ更新し、CSS transitionが慣性を担う。
       ヒーロー画面外・タブ非表示では停止、離脱時はゆっくり中央へ戻る */
    if (cfg.enable && cfg.hero && !reduced &&
        window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)').matches) {
      /* シーン版ヒーローは__mediaが非表示のことがある → その場合はbgart(合成シーン)を動かす */
      var parMedia = document.querySelector('.xc-hero--scene .xc-hero__media');
      if (parMedia && parMedia.offsetParent === null) parMedia = null;
      parMedia = parMedia || document.querySelector('.xc-hero--scene .xc-hero__bgart');
      var parHero = parMedia && parMedia.closest('.xc-hero');
      if (parMedia && parHero) {
        var parActive = true, parRaf = 0, parEvt = null;
        var parReset = function () {
          parMedia.style.removeProperty('--xc-par-x');
          parMedia.style.removeProperty('--xc-par-y');
          parMedia.style.removeProperty('--xc-par-r');
        };
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (en) {
            parActive = en[0].isIntersecting;
            if (!parActive) parReset();
          }, { threshold: 0 }).observe(parHero);
        }
        document.addEventListener('visibilitychange', function () {
          if (document.visibilityState === 'hidden') parReset();
        });
        parHero.addEventListener('pointermove', function (e) {
          if (!parActive || document.visibilityState === 'hidden') return;
          parEvt = e;
          if (parRaf) return;
          parRaf = requestAnimationFrame(function () {
            parRaf = 0;
            var nx = (parEvt.clientX / window.innerWidth - 0.5) * 2;
            var ny = (parEvt.clientY / window.innerHeight - 0.5) * 2;
            parMedia.style.setProperty('--xc-par-x', (nx * 6).toFixed(1) + 'px');
            parMedia.style.setProperty('--xc-par-y', (ny * 4).toFixed(1) + 'px');
            parMedia.style.setProperty('--xc-par-r', (nx * 0.25).toFixed(2) + 'deg');
          });
        }, { passive: true });
        parHero.addEventListener('pointerleave', parReset);
      }
    }

    /* ---------- PCヒーロー: 一度限りの金属走査光(商品PNGでマスク=背景に光が漏れない) ---------- */
    if (cfg.enable && cfg.hero && cfg.gloss && !reduced &&
        window.matchMedia('(min-width: 990px)').matches) {
      var sheenMedia = document.querySelector('.xc-hero--scene .xc-hero__media');
      var sheenMasked = true;
      if (sheenMedia && sheenMedia.offsetParent === null) sheenMedia = null;
      if (!sheenMedia) {
        /* 合成シーン(不透明)に切替: マスクなし+輝度を下げた広い光帯 */
        sheenMedia = document.querySelector('.xc-hero--scene .xc-hero__bgart');
        sheenMasked = false;
      }
      var sheenImg = sheenMedia && sheenMedia.querySelector('img');
      if (sheenMedia && sheenImg && !sheenMedia.querySelector('.xc-anim-sheen')) {
        var runSheen = function () {
          var src = sheenImg.currentSrc || sheenImg.src;
          if (!src || !document.documentElement.classList.contains('xc-booted')) return;
          if (sheenMasked && !('maskImage' in sheenMedia.style) && !('webkitMaskImage' in sheenMedia.style)) return;
          var ov = document.createElement('span');
          ov.className = 'xc-anim-sheen';
          ov.setAttribute('aria-hidden', 'true');
          if (sheenMasked) ov.style.setProperty('--xc-sheen-mask', 'url("' + src + '")');
          else ov.style.setProperty('--xc-sheen-a', '0.14');
          sheenMedia.appendChild(ov);
          requestAnimationFrame(function () { ov.classList.add('is-run'); });
          setTimeout(function () { if (ov.parentNode) ov.parentNode.removeChild(ov); }, 1600);
        };
        /* 起動シーケンス(設置)完了後に1度だけ */
        setTimeout(function () {
          if (sheenImg.complete) runSheen();
          else sheenImg.addEventListener('load', runSheen, { once: true });
        }, 1250);
      }
    }

    /* ---------- 英字キッカーのデコード表示(モバイル・一度限り) ----------
       文字数を変えずスクランブル→左から確定。読み上げは元テキスト(aria-label)を維持 */
    if (cfg.enable && !reduced && window.matchMedia('(max-width: 989px)').matches &&
        'IntersectionObserver' in window) {
      var XC_DECODE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789<>/-_';
      var xcDecode = function (el) {
        if (el.dataset.xcDecoded) return;
        el.dataset.xcDecoded = '1';
        var orig = el.textContent;
        if (!orig || !orig.trim() || orig.length > 44 || el.children.length) return;
        el.setAttribute('aria-label', orig);
        var t0 = null, dur = 520;
        var step = function (ts) {
          if (!t0) t0 = ts;
          var p = Math.min(1, (ts - t0) / dur);
          var fixed = Math.floor(p * orig.length);
          var out = '';
          for (var i = 0; i < orig.length; i++) {
            var ch = orig.charAt(i);
            if (i < fixed || ch === ' ' || ch === '&' || ch === '・' || ch === ' ') out += ch;
            else out += XC_DECODE_CHARS.charAt((Math.random() * XC_DECODE_CHARS.length) | 0);
          }
          el.textContent = out;
          if (p < 1) { requestAnimationFrame(step); }
          else { el.textContent = orig; el.removeAttribute('aria-label'); }
        };
        requestAnimationFrame(step);
      };
      var dio = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          if (en.isIntersecting) { xcDecode(en.target); dio.unobserve(en.target); }
        });
      }, { threshold: 0.6 });
      document.querySelectorAll('.xc-sechead .xc-kicker, .xc-tmhero-overline').forEach(function (el) {
        dio.observe(el);
      });
    }

    /* ---------- 同意チェックON: 購入プレートのアンロック波(一度ずつ) ---------- */
    if (cfg.enable && !reduced) {
      document.querySelectorAll('[data-xc-ack-cb]').forEach(function (cb) {
        cb.addEventListener('change', function () {
          if (!cb.checked) return;
          var form = cb.closest('form');
          var plate = form && form.querySelector('[data-xc-add]');
          if (!plate) return;
          plate.classList.remove('xc-anim-unlock');
          void plate.offsetWidth;
          plate.classList.add('xc-anim-unlock');
          setTimeout(function () { plate.classList.remove('xc-anim-unlock'); }, 900);
        });
      });
    }

    /* ---------- BFCache復帰(ブラウザバック): 演出が完了状態で固まるため一度だけ再生 ---------- */
    if (cfg.enable && !reduced) {
      window.addEventListener('pageshow', function (e) {
        if (!e.persisted) return;
        var r2 = document.documentElement;
        r2.classList.remove('xc-booted');
        void document.body.offsetWidth;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { r2.classList.add('xc-booted'); });
        });
      });
    }

    /* ---------- テーマエディター: セクション再読込時に非表示のまま残さない ---------- */
    document.addEventListener('shopify:section:load', function (ev) {
      if (!ev.target) return;
      ev.target.querySelectorAll('[data-xc-reveal]').forEach(function (el) {
        el.classList.add('is-in');
      });
    });
  });
})();
